// Tipos para o Cadastro de Kits N1

export interface IKit {
  idKit?: number;
  codigo: string;
  codigoInterno?: string;
  descricao: string;
  idSituacao: number;
  idStatus: number;
  idReferencia?: number;
  idLinha: number; // Obrigatório
  idGrupo: number; // Obrigatório
  idTipo?: number; // 1 = Ferragem, 2 = Engenharia
  tipo?: string; // 'Ferragem' | 'Engenharia'
  
  // Mídia
  imagemUrl?: string;
  imagemNomeArquivo?: string;
  
  // Listas relacionadas
  medidas?: IKitMedida[];
  espessuras?: IKitEspessura[];
  cores?: IKitCor[];
  composicao?: IKitComposicao[];
  
  // Auditoria
  dataUltimaAtualizacao?: string;
  dataCriacao?: string;
  editavel?: boolean;
  excluido?: boolean;
}

export interface IKitMedida {
  idMedidaCores?: number;
  // FASE 05 — 4ª validação/Frente 9 2026-07-30: limite ampliado de 999 para 99999 (5 caracteres).
  larguraMm?: number; // ≥ 0, ≤ 99999
  alturaMm?: number; // ≥ 0, ≤ 99999
  ordem?: number;
}

export interface IKitEspessura {
  idMedidaCores?: number;
  espessura: number; // ≥ 0, ≤ 999
  ordem?: number;
}

export interface IKitCor {
  idKitCor?: number;
  idCor: number;
  corDescricao?: string;
  ordem?: number;
}

export interface IKitComposicao {
  idKitComposicao?: number;
  tipoProduto: 'Perfil' | 'Componente' | 'Livre';
  codigo: string;
  descricao: string;
  idUnidade: number;
  unidadeDescricao?: string;
  quantidade: number; // ≥ 1
  defVariaveisUsinagem?: string;
  ordem?: number;
  
  // Campos auxiliares para busca (não enviados ao backend)
  idPerfil?: number;
  idComponente?: number;
  unidadeNome?: string; // Nome da unidade para exibição
}

export interface ISelectOption {
  id: number;
  nome: string;
  descricao?: string;
  codigo?: string;
  sigla?: string;
}

export type KitTabIndex = 0 | 1 | 2;
export const KIT_TABS = ['GERAL', 'DADOS ADICIONAIS', 'COMPOSIÇÃO'] as const;

// FASE 05 — 4ª validação/D3 2026-07-30: semântica legada — 3 = Disponível mercado,
// 4 = Indisponível (fora do fluxo), 5 = Homologado (estado novo do fluxo).
export const SITUACAO_OPTIONS = [
  { id: 1, label: 'Em edição' },
  { id: 2, label: 'Em homologação' },
  { id: 3, label: 'Disponível mercado' },
  { id: 4, label: 'Indisponível' },
  { id: 5, label: 'Homologado' },
];

export const STATUS_OPTIONS = [
  { id: 1, label: 'Ativo' },
  { id: 2, label: 'Descontinuado' },
  // FASE 05 — 2ª validação/PO 2026-07-24 (Frente 7, P5): "Inativo" removido do front.
];

export const TIPO_KIT_OPTIONS = [
  { id: 1, label: 'Ferragem', value: 'Ferragem' },
  { id: 2, label: 'Engenharia', value: 'Engenharia' },
];

export const TIPO_PRODUTO_OPTIONS = [
  { id: 'Perfil', label: 'Perfil' },
  { id: 'Componente', label: 'Componente' },
  { id: 'Livre', label: 'Livre' },
];
